export default "__VITE_ASSET__BHhczez2__"